import { render } from "./WidgetUsuario.vue?vue&type=template&id=4c367438&scoped=true&ts=true"
import script from "./WidgetUsuario.vue?vue&type=script&lang=ts"
export * from "./WidgetUsuario.vue?vue&type=script&lang=ts"

import "./WidgetUsuario.vue?vue&type=style&index=0&id=4c367438&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c367438"]])

export default __exports__